import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { TextField, Step } from '../SteppedForm';

import rules from './rules';

const StepFinprovider = (props) => {
  return (
    <Step
      id="finprovider"
      title="Vehicle - Finance Provider"
      skip={(formdata) =>
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        !formdata.vehicles[props.state.vehicle_index].carbuy ||
        formdata.vehicles[props.state.vehicle_index].carfin ||
        !props.networkconfig().carfin ||
        !props.stateconfig().carfinance
      }>
      <Typography variant="body1" class="formQuestion">
        If you are not financing a car with 13cabs but would like purchase one, please provide the
        details of the person/company you are financing your car through.
      </Typography>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField
            id="carfin_busname"
            label="Business Name"
            valid={rules.safeText}
            required={props.state.formdata.state !== 'nsw'}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="carfin_name"
            label="Contact Name"
            valid={rules.safeText}
            required={props.state.formdata.state !== 'nsw'}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="carfin_phone"
            type="tel"
            inputProps={{ maxLength: 16 }}
            label="Phone"
            valid={rules.phone}
            required={props.state.formdata.state !== 'nsw'}
          />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="carfin_email"
            label="Email"
            valid={rules.email}
            required={props.state.formdata.state !== 'nsw'}
          />
        </Grid>
      </Grid>
    </Step>
  );
};

export default StepFinprovider;
